// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38BK5","type":"styles_type__IdNRi","choices":"styles_choices__3VFRx"};